import { useState, useEffect } from 'react'
import { Button, Spinner, Tooltip } from '@fluentui/react-components'
import { useProjektprognosEditingContext } from '../../context/ProjektprognosEditingContext'
import { useUpdateProjectForecast } from '../../fetchData/mutations/useUpdateProjectForecast'
import { ActionConfirmationModal } from '../Shared/ActionConfirmationModal'
import styles from './UpdatePeriodReportButton.module.css'

const UpdatePeriodReportButton = () => {
  const { selectedPeriodReport } = useProjektprognosEditingContext()
  const reportGuid = selectedPeriodReport?.id || null
  const { mutate, isPending, error, reset } =
    useUpdateProjectForecast(reportGuid)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)

  // Handle success state with timeout
  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    if (showSuccess) {
      timeoutId = setTimeout(() => {
        setShowSuccess(false)
      }, 2000)
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [showSuccess])

  const handleOpen = () => {
    if (!reportGuid || isPending) return
    reset()
    setIsModalOpen(true)
  }

  const handleClose = () => {
    reset()
    setIsModalOpen(false)
  }

  const handleConfirm = () => {
    if (!reportGuid) return

    mutate(undefined, {
      onSuccess: () => {
        setIsModalOpen(false)
        setShowSuccess(true)
      },
    })
  }

  const isOngoingStatus = selectedPeriodReport?.status === 'Ongoing'
  const isDisabled = !reportGuid || isPending || !isOngoingStatus

  const tooltipText = !isOngoingStatus
    ? 'Kan endast uppdatera rapporter med status "Ongoing"'
    : !reportGuid
      ? 'Välj en rapport först'
      : 'Hämta senaste bokförda värden och uppdatera prognosen'

  return (
    <>
      <Tooltip content={tooltipText} relationship="label" positioning="above">
        <Button onClick={handleOpen} disabled={isDisabled}>
          {isPending && <Spinner size="tiny" className={styles.spinner} />}
          <span>Uppdatera rapport</span>
        </Button>
      </Tooltip>

      <ActionConfirmationModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isPending}
        error={error}
        onReset={reset}
        title="Uppdatera rapport"
        message="När du uppdaterar siffrorna i prognossammanställningen kommer dessa ändringar att sparas ner och användas som föregående prognos för nästa prognosperiod. Är du säker på att du vill uppdatera prognossammanställningen?"
        confirmLabel="Uppdatera"
      />
    </>
  )
}

export default UpdatePeriodReportButton
